export const FETCH_BUSINESS_CATEGORIES_REQUEST =
  'businessCategories/FETCH_BUSINESS_CATEGORIES_REQUEST'
export const FETCH_BUSINESS_CATEGORIES_SUCCESS =
  'businessCategories/FETCH_BUSINESS_CATEGORIES_SUCCESS'
export const FETCH_BUSINESS_CATEGORIES_FAILURE =
  'businessCategories/FETCH_BUSINESS_CATEGORIES_FAILURE'

export const FETCH_BUSINESS_CATEGORY_REQUEST =
  'businessCategories/FETCH_BUSINESS_CATEGORY_REQUEST'
export const FETCH_BUSINESS_CATEGORY_SUCCESS =
  'businessCategories/FETCH_BUSINESS_CATEGORY_SUCCESS'
export const FETCH_BUSINESS_CATEGORY_FAILURE =
  'businessCategories/FETCH_BUSINESS_CATEGORY_FAILURE'

export const DELETE_BUSINESS_CATEGORY_REQUEST =
  'businessCategories/DELETE_BUSINESS_CATEGORY_REQUEST'
export const DELETE_BUSINESS_CATEGORY_SUCCESS =
  'businessCategories/DELETE_BUSINESS_CATEGORY_SUCCESS'
export const DELETE_BUSINESS_CATEGORY_FAILURE =
  'businessCategories/DELETE_BUSINESS_CATEGORY_FAILURE'

export const CREATE_BUSINESS_CATEGORY_REQUEST =
  'businessCategories/CREATE_BUSINESS_CATEGORY_REQUEST'
export const CREATE_BUSINESS_CATEGORY_SUCCESS =
  'businessCategories/CREATE_BUSINESS_CATEGORY_SUCCESS'
export const CREATE_BUSINESS_CATEGORY_FAILURE =
  'businessCategories/CREATE_BUSINESS_CATEGORY_FAILURE'

export const UPDATE_BUSINESS_CATEGORY_REQUEST =
  'businessCategories/UPDATE_BUSINESS_CATEGORY_REQUEST'
export const UPDATE_BUSINESS_CATEGORY_SUCCESS =
  'businessCategories/UPDATE_BUSINESS_CATEGORY_SUCCESS'
export const UPDATE_BUSINESS_CATEGORY_FAILURE =
  'businessCategories/UPDATE_BUSINESS_CATEGORY_FAILURE'

export const UPDATE_FIELD = 'businessCategories/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'businessCategories/SET_DEFAULT_DATA'

export const CREATE_BUSINESS_SUBCATEGORY_REQUEST =
  'businessCategories/CREATE_BUSINESS_SUBCATEGORY_REQUEST'
export const CREATE_BUSINESS_SUBCATEGORY_SUCCESS =
  'businessCategories/CREATE_BUSINESS_SUBCATEGORY_SUCCESS'
export const CREATE_BUSINESS_SUBCATEGORY_FAILURE =
  'businessCategories/CREATE_BUSINESS_SUBCATEGORY_FAILURE'

export const DELETE_BUSINESS_SUBCATEGORY_REQUEST =
  'businessCategories/DELETE_BUSINESS_SUBCATEGORY_REQUEST'
export const DELETE_BUSINESS_SUBCATEGORY_SUCCESS =
  'businessCategories/DELETE_BUSINESS_SUBCATEGORY_SUCCESS'
export const DELETE_BUSINESS_SUBCATEGORY_FAILURE =
  'businessCategories/DELETE_BUSINESS_SUBCATEGORY_FAILURE'

export const FETCH_BUSINESS_SUBCATEGORY_REQUEST =
  'businessCategories/FETCH_BUSINESS_SUBCATEGORY_REQUEST'
export const FETCH_BUSINESS_SUBCATEGORY_SUCCESS =
  'businessCategories/FETCH_BUSINESS_SUBCATEGORY_SUCCESS'
export const FETCH_BUSINESS_SUBCATEGORY_FAILURE =
  'businessCategories/FETCH_BUSINESS_SUBCATEGORY_FAILURE'

export const UPDATE_BUSINESS_SUBCATEGORY_REQUEST =
  'businessCategories/UPDATE_BUSINESS_SUBCATEGORY_REQUEST'
export const UPDATE_BUSINESS_SUBCATEGORY_SUCCESS =
  'businessCategories/UPDATE_BUSINESS_SUBCATEGORY_SUCCESS'
export const UPDATE_BUSINESS_SUBCATEGORY_FAILURE =
  'businessCategories/UPDATE_BUSINESS_SUBCATEGORY_FAILURE'
